function paragraphFromText(text: string) {
  return {
    type: 'paragraph' as const,
    children: [
      {
        type: 'text' as const,
        detail: 0,
        format: 0,
        mode: 'normal' as const,
        style: '',
        text,
        version: 1,
      },
    ],
    direction: 'ltr' as const,
    format: '' as const,
    indent: 0,
    version: 1,
  }
}

/**
 * Converts BillTrack50 plaintext (often multi-paragraph AI summaries) into Lexical rich text.
 */
export const billTrack50PlainTextToRichText = (text?: string | null) => {
  const trimmed = text?.trim() ?? ''
  if (!trimmed) {
    return plainTextToRichText('')
  }

  const paragraphs = trimmed
    .split(/\n\n+/)
    .map((paragraph) => paragraph.trim())
    .filter(Boolean)

  return plainTextToRichText(paragraphs.length > 0 ? paragraphs : trimmed)
}

/** Convert plain text into Lexical richText. A string stays one paragraph. */
export const plainTextToRichText = (text?: string | string[] | null) => {
  const paragraphs = Array.isArray(text)
    ? text.map((paragraph) => paragraph?.trim() ?? '').filter(Boolean)
    : typeof text === 'string' && text
      ? [text]
      : ['']

  return {
    root: {
      type: 'root' as const,
      children: paragraphs.length > 0 ? paragraphs.map(paragraphFromText) : [paragraphFromText('')],
      direction: 'ltr' as const,
      format: '' as const,
      indent: 0,
      version: 1,
    },
  }
}
